import React, { useEffect, useState }  from 'react';
import { SlArrowRight } from 'react-icons/sl';
import DropList from './DropList';


const NotificationItem = ({item}) => {
    const [styleLable, setStyleLable] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [openList, setOpenList] = useState(false)
    
    useEffect(() => {
        if (isOpen){
            setTimeout(() => {
                setOpenList(true)
            },100)
        } else setOpenList(false)
      },[isOpen])

    return (
        <div className={`notification_item_wrap ${openList ? 'open_drop_menu' : 'close_drop_menu'}`}>
            <div className={`notification_item_wrap_dropdown `}>
                <div className='img_notification'>
                    <img  src={`./img/notif_img/${item.iconNotif}`} alt="" />
                    <div className={`notification_triger ${item.colorNotif} `}></div>
                </div>
                <div className='img_user'>
                    <img  src={`./img/notif_img/${item.iconUser}`} alt="" />
                </div>
                <div className='notification_info'>
                    <h3>{item.infoH3}</h3>
                    <p>{item.infoText}</p>
                </div>
                <div className='notification_label'>
                    {item?.lable.map((lable, idx) => (

                    <p 
                    className={lable}
                    key={idx}>{lable}</p>
                        // if (lable == 'Anti-Webhook'){
                            
                        // } else{
                        //     setStyleLable('none')
                        // }
                        // return(
                        //     <p className={`${styleLable}`} key={idx}>{lable}</p>

                        // );
                    ))}
                </div>
                <div className='notification_open-drop'>
                    <SlArrowRight
                    className={`close_svg ${isOpen? 'open_svg' : ''}`}
                    onClick={() => setIsOpen(state => !state)}
                    />
                </div>
            </div>
                <DropList
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                lorem={item.textDrop}
                />
        </div>
    );
};

export default NotificationItem;